import React from 'react'
import { connect } from 'redaction'
import { compose, links } from 'helpers'
import injectGlobals from 'local_modules/injectGlobals'

import Link from 'components/ui/Link/Link'

import s from './LoginLink.scss'


const LoginLink = ({ link }) => (
  <Link
    className={s.link}
    title="Войти"
    target="_self"
    toOLD={link === links.marketplace.login ? null : link}
    to={link === links.marketplace.login ? link : null}
  />
)


export default compose(
  injectGlobals(({ getCookieValue }) => ({
    userName: getCookieValue('userName')
  })),
  connect({
    link: (state, props) => {
      const {
        me: { layers },
        routing: { locationBeforeTransitions: { pathname } },
      } = state

      if (props.userName) {
        return links.marketplace.login
      }

      let pageId = ''

      layers.some(({ id, link, title }) => {
        return pathname.includes(link) ? pageId = id : false
      })

      return `/login/${pageId}`
    }
  }),
)(LoginLink)
